var EmbedPolicy = require("./embed_policy").default;

export default class LivestreamingOverlay extends EmbedPolicy {
  init() {
    this.getReferrerDomain();
    this.getAllowedDomains();
    this.isAllowed();
    this.showHideOverlay();
    $(this.element()).click(this.onClick.bind(this));
    this._disposeCounter = 0;
    this._disposeIntervalId = null;
  }

  element() {
    return this.$element;
  }

  onClick() {
    this.sendGaEvent();
  }

  sendGaEvent(){
    var eventType = this.getEventType();

    window.ga('kmkGATracker.send', {
      hitType: 'event',
      eventCategory: "widget",
      eventAction: "click",
      eventLabel: "livestreaming / " + eventType + " / " + this.referrer,
      transport: 'beacon'
    });
  }

  getAllowedDomains() {
    this.allowedDomains = this.element().data('allowed-domains');
  }

  showHideOverlay() {
    if(this.isLivestreaming() && !this.siteAllowed){
      this.showOverlay();
    }
  }

  isLivestreaming() {
    return this.element().length != 0;
  }

  showOverlay() {
    var timeout = this.getTimeout();
    setTimeout(this.spawnOverlay.bind(this), timeout);
  }

  getEventType() {
    var eventType = this.element().data('stream-type');
    if( eventType !== undefined ) {
      eventType = eventType.replace('Stream', '').toLowerCase();
    }
    return eventType;
  }

  getTimeout() {
    var time = 0;
    if (document.querySelector('.player-data') !== null) {
      time = document.querySelector('.player-data').getAttribute('data-embed-time');
    }
    return (time ? +time : 30)  * 1000;
  }

  spawnOverlay() {
    this.disablePlayer();
    this.unhideElement();
  }

  unhideElement() {
    this.element().removeClass("hide");
  }

  disablePlayer() {
    this._disposeIntervalId = setInterval(this.disposePlayer.bind(this), 100);
  }

  disposePlayer() {
    if(window.player && window.player.tech() && window.player.tech().plugin()) {
      window.player.tech().dispose();
      clearInterval(this._disposeIntervalId);
      this._disposeIntervalId = null;
    } else if(this._disposeCounter == 100) {
      clearInterval(this._disposeIntervalId);
      this._disposeIntervalId = null;
    }
    this._disposeCounter++;
  }
}
